import { Component, OnInit ,AfterViewInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {DataService} from '../data.service';
import {HomeComponent} from '../home/home.component';

declare var $:any;

@Component({
  selector: 'app-subscription-details',
  templateUrl: './subscription-details.component.html',
  styleUrls: ['./subscription-details.component.css']
})
export class SubscriptionDetailsComponent implements OnInit,AfterViewInit {
  userId:number=-1;
  userTypeId:number=-1;
  data:any[]=[];
  planId:number=-1;
  isNext:boolean=false;
  companyId:number=-1;

  constructor(private route:ActivatedRoute,private service:DataService,private home:HomeComponent) { }

  ngOnInit() {
    this.route.params.subscribe(params=>{
      this.userId=params['id'];
    })

    this.userTypeId=localStorage.getItem("UserTypeId")==null ? -1 : parseInt(localStorage.getItem("UserTypeId"));
    this.planId=localStorage.getItem("planId")==null ? -1 : parseInt(localStorage.getItem("planId"));
    this.companyId=sessionStorage.getItem('companyId')==null ? -1 :parseInt(sessionStorage.getItem('companyId'));
    this.getSubScribeUser();
  }

  ngAfterViewInit(){
    $('.cd-header').css('background-color','#941246');
  }

  getSubScribeUser(){
    const inputJson={
      "CompanyId":this.companyId,
    	"Type":"",
    	"UserId":this.userId,
    	"UserType":this.userTypeId
    }
    
    this.service.GetSubScribeUser(inputJson)
    .subscribe(
    (result:any[])=>{
      if(result['Status']=="Success"){
        this.data=result['SubScribeUserData'];
      }else{
        this.service.alert(result['Message'],'error')
      }
    },
    (error)=>{
      console.log(error);
    }
    )
  }

  getStatus(date):string{
    var d=new Date(date);
    if(d>new Date()){
      return "Active"
    }else{
      return "Expired"
    }
  }

  showActiveModule(pvarId){
    this.home.showActiveModule(pvarId);
  }

}



// WEBPACK FOOTER //
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/app/subscription-details/subscription-details.component.ts